<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable width="400">

      <v-card>

        <v-card-title>
          Filtrer par
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">

          <label>
            Date d'envoi
          </label>
          <v-date-picker v-model="filter.dates"
                         full-width
                         no-title
                         range
          ></v-date-picker>

          <label>
            Campagne avec un fichier excel
          </label>
          <v-radio-group v-model="filter.excel_file" hide-details label="" row>
            <v-radio label="Oui" value="yes"></v-radio>
            <v-radio label="Non" value="no"></v-radio>
            <v-radio label="Tous" value="all"></v-radio>
          </v-radio-group>

        </v-card-text>

        <v-divider/>

        <v-card-actions class="grey lighten-4">
          <v-spacer/>
          <v-btn color="secondary"
                 depressed
                 @click="search">
            <v-icon left>mdi-magnify</v-icon>
            Recherche
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
    data() {
        return {
            isLoading: false,
            dialog: false,
            filter: {
                dates: [],
                excel_file: 'all',
            },
        }
    },
    methods: {
        open() {
            this.dialog = true
            this.filter = {
                dates: [],
                excel_file: 'all',
            }
        },
        search() {
            this.dialog = false
            this.$emit('search', this.filter)
        },
    }
}
</script>

<style scoped>

</style>